import api from '@/api'

export default {
  getSelfInfo ({ commit, dispatch }) {
    return api.chat
      .getSelfInfo()
      .then(({ accid, icon, name, token }) => {
        commit('saveUserInfo', { accid, icon, name, token })
        return Promise.resolve({ accid, icon, name, token })
      })
  },
  getChatroomAddress (context, { roomid, accid }) {
    return api.chat.getChatroomAddress({ roomid, accid })
  },
  sendMsg (context, { attach, roomid, msgType, ext }) {
    api.chat
      .sendMsg({ attach, roomid, msgType, ext })
  },
  getMsgNum (context, { roomid }) {
    return api.chat.getMsgNum({ roomid })
  },
  saveMsg (context, { attach, roomid, msgType, ext, msgId }) {
    return api.chat.saveMsg({ attach, roomid, msgType, ext, msgId })
  },
  sendGift (context, { attach, roomid, msgType, ext, consumeType, consumeValue }) {
    return api.chat.sendGift({ attach, roomid, msgType, ext, consumeType, consumeValue })
  },
  async getMyPower () {
    let data = await api.user.getMyPower()
    return data
  },
  updateBroadcast ({ commit }, { courseId }) {
    return api.chat.getBroadcast({ courseId })
      .then(data => {
        let content = data ? data.content : ''
        commit('updateBroadcast', { courseId, content })
      })
  },
  async getSensitive () {
    let data = await api.chat.getSensitive()
    return data
  },
}
